import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import AdminSidebar from './AdminSidebar';
import { getAdminPageTitle } from './adminMenu';

export default function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const title = getAdminPageTitle(location.pathname);

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/sign-in');
    } catch {
      // ignore sign-out errors
    }
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <div className="flex">
        {/* Desktop sidebar */}
        <aside className="hidden lg:flex flex-col w-64 shrink-0 sticky top-0 h-screen bg-white border-r border-stone-200">
          <AdminSidebar />
        </aside>

        {/* Mobile drawer */}
        {mobileOpen && (
          <div className="fixed inset-0 z-50 lg:hidden">
            <div className="absolute inset-0 bg-black/40" onClick={() => setMobileOpen(false)} />
            <aside className="absolute inset-y-0 left-0 w-64 bg-white flex flex-col">
              <AdminSidebar onNavigate={() => setMobileOpen(false)} />
              <button
                type="button"
                onClick={() => setMobileOpen(false)}
                className="absolute top-4 right-3 w-8 h-8 flex items-center justify-center rounded-lg text-stone-400 hover:text-stone-600 hover:bg-stone-100 cursor-pointer"
              >
                <i className="ri-close-line text-lg" />
              </button>
            </aside>
          </div>
        )}

        {/* Main column */}
        <div className="flex-1 min-w-0 flex flex-col">
          {/* Top bar */}
          <header className="sticky top-0 z-20 bg-white/90 backdrop-blur border-b border-stone-200">
            <div className="h-16 px-4 md:px-8 flex items-center justify-between gap-4">
              <div className="flex items-center gap-3 min-w-0">
                <button
                  type="button"
                  onClick={() => setMobileOpen(true)}
                  className="lg:hidden w-9 h-9 flex items-center justify-center rounded-lg text-stone-600 hover:bg-stone-100 cursor-pointer shrink-0"
                >
                  <i className="ri-menu-line text-lg" />
                </button>
                <h1 className="text-lg font-bold text-stone-900 truncate">{title}</h1>
              </div>

              <div className="flex items-center gap-2 shrink-0">
                {user && (
                  <span className="hidden md:inline text-xs text-stone-500 max-w-[180px] truncate">
                    {user.email}
                  </span>
                )}
                <button
                  type="button"
                  onClick={() => navigate('/')}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-lg border border-stone-300 text-stone-600 hover:bg-stone-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-external-link-line" />
                  사이트 보기
                </button>
                <button
                  type="button"
                  onClick={handleSignOut}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-lg bg-stone-900 text-white hover:bg-stone-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-logout-box-r-line" />
                  로그아웃
                </button>
              </div>
            </div>
          </header>

          <main className="flex-1">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}